import * as types from '../../../lib/actionTypes.es6';

export var getOrgClaimProcConfigsRequest = function(organizationGuid) {
  return { type: types.GET_ORG_CLAIM_PROC_CONFIGS_REQUEST, payload: organizationGuid };
};
export var getOrgClaimProcConfigsSuccess = function(payload) {
  return { type: types.GET_ORG_CLAIM_PROC_CONFIGS_SUCCESS, payload: payload };
};
export var getOrgClaimProcConfigsFailure = function(error) {
  return { type: types.GET_ORG_CLAIM_PROC_CONFIGS_FAILURE, payload: error };
};
export var createOrgClaimProcConfigRequest = function(payload) {
  return { type: types.CREATE_ORG_CLAIM_PROC_CONFIG_REQUEST, payload: payload };
};
export var createOrgClaimProcConfigSuccess = function(payload) {
  return { type: types.CREATE_ORG_CLAIM_PROC_CONFIG_SUCCESS, payload: payload };
};
export var createOrgClaimProcConfigFailure = function(error) {
  return { type: types.CREATE_ORG_CLAIM_PROC_CONFIG_FAILURE, payload: error };
};
export var resetCreateOrgClaimProcConfigSuccess = function() {
  return { type: types.RESET_CREATE_ORG_CLAIM_PROC_CONFIG_SUCCESS };
};
export var resetCreateOrgClaimProcConfigError = function() {
  return { type: types.RESET_CREATE_ORG_CLAIM_PROC_CONFIG_ERROR };
};
export var updateOrgClaimProcConfigRequest = function(payload) {
  return { type: types.UPDATE_ORG_CLAIM_PROC_CONFIG_REQUEST, payload: payload };
};
export var updateOrgClaimProcConfigSuccess = function(payload) {
  return { type: types.UPDATE_ORG_CLAIM_PROC_CONFIG_SUCCESS, payload: payload };
};
export var updateOrgClaimProcConfigFailure = function(error) {
  return { type: types.UPDATE_ORG_CLAIM_PROC_CONFIG_FAILURE, payload: error };
};
export var resetUpdateOrgClaimProcConfigSuccess = function() {
  return { type: types.RESET_UPDATE_ORG_CLAIM_PROC_CONFIG_SUCCESS };
};
export var resetUpdateOrgClaimProcConfigError = function() {
  return { type: types.RESET_UPDATE_ORG_CLAIM_PROC_CONFIG_ERROR };
};
export var deleteOrgClaimProcConfigRequest = function(payload) {
  return { type: types.DELETE_ORG_CLAIM_PROC_CONFIG_REQUEST, payload: payload };
};
export var deleteOrgClaimProcConfigSuccess = function(payload) {
  return { type: types.DELETE_ORG_CLAIM_PROC_CONFIG_SUCCESS, payload: payload };
};
export var deleteOrgClaimProcConfigFailure = function(error) {
  return { type: types.DELETE_ORG_CLAIM_PROC_CONFIG_FAILURE, payload: error };
};
export var resetDeleteOrgClaimProcConfigSuccess = function() {
  return { type: types.RESET_DELETE_ORG_CLAIM_PROC_CONFIG_SUCCESS };
};
export var resetDeleteOrgClaimProcConfigError = function() {
  return { type: types.RESET_DELETE_ORG_CLAIM_PROC_CONFIG_ERROR };
};
